import * as React from 'react';
import { 
  Typography, 
  Box, 
  Button, 
  Chip, 
  Grid, 
  IconButton,
  Stack,
  Divider,
  Card,
  CardContent,
  CardActions,
  Tooltip
} from '@mui/material';
import { connect } from "react-redux";
import { NavLink, useNavigate } from 'react-router-dom';
import { MainInput, SecInput, TerInput, centered_flex_box, left_flex_box, main_button, sec_button } from './Styles';
import moment from "moment"
import { isMobile } from 'react-device-detect';
import DownloadIcon from '@mui/icons-material/Download';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import QRCode from "react-qr-code";
import PaymentIcon from '@mui/icons-material/Payment';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { downloadTicket, payTicketRequest } from '../store/actions/userActions';
import { acceptTicketRequest, fulfillTicketRequest, rejectTicketRequest } from '../store/actions/adminActions';
import ReactFileReader from 'react-file-reader';
import UploadIcon from '@mui/icons-material/Upload';
import { config } from "../../app/config";
import { uploadFile } from '../../core/aws';
import { motion } from 'framer-motion';
import { eventSurfacePaperSx, marketingColors, marketingFonts } from './tickitMarketingTheme';
const { v4: uuidv4 } = require('uuid');

function RequestCard({ request, downloadTicket, token, acceptTicketRequest, rejectTicketRequest, fulfillTicketRequest, payTicketRequest, action, setAction }) {
    window.Buffer = window.Buffer || require("buffer").Buffer;
    const role = token.split(" ")[0]
    const navigate = useNavigate();
    const [showQr, setShowQr] = React.useState(false);
    const [showReceipt, setShowReceipt] = React.useState(false);
    const [showDetails, setShowDetails] = React.useState(false);
    const [showUploadReceipt, setShowUploadReceipt] = React.useState(false);
    const [showCashMethod, setShowCashMethod] = React.useState(false);
    const [receipt, setReceipt] = React.useState(null)

    function timeout(delay) {
        return new Promise(res => setTimeout(res, delay));
    }

    const handleAddReceipt = files => {
        let file = files[0]
        console.log(file)
        setReceipt(file)
    }

    const handleDeleteReceipt = () => {
        setReceipt(null);
    }

    const handlePayForRequest = async (ev) => {
        ev.preventDefault();
        const data = new FormData(ev.currentTarget);
        let imageUrl;
        if (receipt) {
            imageUrl = await uploadFile(receipt)
        }
        payTicketRequest({ requestId: request._id, receipt: imageUrl, instapayUser: data.get("instapayUser") })
        setAction(!action)
    }

    const handleAccept = async () => {
        acceptTicketRequest({ requestId: request._id })
        await timeout(500)
        setAction(!action)
    }

    const handleReject = async () => {
        rejectTicketRequest({ requestId: request._id })
        await timeout(500)
        setAction(!action)
    }

    const handleFulfill = async () => {
        fulfillTicketRequest({ requestId: request._id, ticketId: request.ticket._id })
        await timeout(500)
        setAction(!action)
    }

    const getStatusChip = () => {
        switch (request.status) {
            case "Accepted":
                return {
                    icon: <CheckCircleIcon />,
                    label: "Accepted",
                    color: "success"
                };
            case "Rejected":
                return {
                    icon: <ErrorIcon />,
                    label: "Rejected",
                    color: "error"
                };
            case "Unseen":
                return {
                    icon: <AccessTimeIcon />,
                    label: "Pending",
                    color: "warning"
                };
            case "Purchased":
                return {
                    icon: <CheckCircleIcon />,
                    label: "Purchased",
                    color: "primary"
                };
            default:
                return {
                    icon: <AccessTimeIcon />,
                    label: request.status,
                    color: "default"
                };
        }
    };

    const status = getStatusChip();

    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
            style={{ width: '100%' }}
        >
            <Card 
                elevation={0}
                sx={{ 
                    ...eventSurfacePaperSx,
                    width: '100%',
                    transition: 'all 0.25s ease',
                    '&:hover': {
                        transform: 'translateY(-4px)',
                        boxShadow: '0 12px 40px rgba(70,16,155,0.12)',
                        borderColor: marketingColors.p300,
                    },
                    '& .MuiTypography-h6': {
                        fontFamily: marketingFonts.display,
                        color: marketingColors.gray900,
                    },
                }}
            >
                <CardContent>
                    <Stack spacing={2}>
                        <Grid container alignItems="center" spacing={1}>
                            <Grid item xs>
                                <Tooltip title={request.event.title} placement="top">
                                    <Typography 
                                        variant="h6" 
                                        fontWeight="bold" 
                                        noWrap
                                        sx={{ 
                                            color: 'var(--primaryPurple)',
                                            fontSize: { xs: '1.1rem', sm: '1.25rem' },
                                            maxWidth: '100%',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis'
                                        }}
                                    >
                        {request.event.title}
                    </Typography>
                                </Tooltip>
                </Grid>
                            <Grid item xs="auto">
                                <Chip 
                                    icon={status.icon}
                                    label={status.label}
                                    color={status.color}
                                    variant="outlined"
                                    size="small"
                                    sx={{ 
                                        minWidth: '80px',
                                        '& .MuiChip-icon': {
                                            fontSize: '1rem'
                                        }
                                    }}
                                />
                </Grid>
            </Grid>

                        <Divider />

                        <Stack spacing={1}>
                            <Typography variant="body2" color="text.secondary">
                            Ticket Holder: {request.userInfo?.name}
                        </Typography>
                            <Typography variant="body2" color="text.secondary">
                            Category: {request.category}
                        </Typography>
                        {(role && role === "User" && (request.status === "Accepted" || request.status === "Unseen")) &&
                                <Typography variant="body2" color="text.secondary">
                                Price: {request.price} EGP
                            </Typography>
                        }
                            {role && role === "User" && !request.receipt && request.status === "Accepted" && moment().isBefore(request.deadline) && (
                                <Typography variant="body2" color="error.main" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                    <AccessTimeIcon fontSize="small" />
                                Request expires {moment(request.deadline).fromNow()}
                            </Typography>
                            )}
                            {role && role === "User" && !request.receipt && request.status === "Accepted" && moment().isAfter(request.deadline) && (
                                <Typography variant="body2" color="error.main" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                    <ErrorIcon fontSize="small" />
                                Request expired
                            </Typography>
                            )}
                        </Stack>

                        {showQr && (
                            <>
                                <Divider />
                                <Box sx={{ 
                                    display: 'flex', 
                                    justifyContent: 'center', 
                                    p: 2,
                                    backgroundColor: 'white',
                                    borderRadius: '8px',
                                    border: '1px solid #e0e0e0'
                                }}>
                                    <QRCode
                                        style={{ 
                                            height: 'auto', 
                                            maxWidth: '70%', 
                                            width: '70%',
                                            backgroundColor: 'white',
                                            padding: '8px',
                                            borderRadius: '4px'
                                        }}
                                        value={request.ticket._id}
                                        fgColor="#000000"
                                        bgColor="#ffffff"
                                    />
            </Box>
                            </>
                        )}

                        {showReceipt && (
                            <>
                                <Divider />
                                <Stack spacing={2}>
                                    <Typography variant="body2" color="text.secondary">
                                        InstaPay Username: {request.instapayUser}
                                    </Typography>
                                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                        <img 
                                            width={"300px"} 
                                            src={request.receipt} 
                                            alt="Receipt" 
                                            style={{ borderRadius: '8px', maxWidth: '100%' }}
                                        />
                    </Box>
                                </Stack>
                            </>
                        )}

                        {showDetails && (
                            <>
                                <Divider />
                                <Stack spacing={1}>
                                    {request.userInfo && Object.keys(request.userInfo).map((data, index) => {
                                        return (
                                            <Typography key={index} variant="body2" color="text.secondary">
                                                {data === "phoneNumber" ? "Phone Number" : data}: {
                                                    data.includes("Link") ? 
                                                        <NavLink className="a2" target="_blank" to={request.userInfo[data]} style={{ color: 'inherit' }}>
                                                            {request.userInfo[data]}
                                                        </NavLink> : 
                                                        request.userInfo[data]
                                                }
                                            </Typography>
                                        )
                                    })}
                                </Stack>
                            </>
                        )}

            {showUploadReceipt && (
                            <>
                                <Divider />
                                <Card 
                                    variant="outlined" 
                                    sx={{ 
                                        backgroundColor: 'white', 
                                        border: '1px solid #e0e0e0',
                                        borderRadius: '8px'
                                    }}
                                >
                                    <CardContent>
                                        <Stack spacing={2}>
                                            <Typography variant="h6" fontWeight="bold" color="var(--primaryPurple)">
                                                Pay To:
                                            </Typography>
                                            {request.event.paymentAddress.map((add, index) => {
                                                return <Typography key={index} variant="body2">{add}</Typography>
                        })}
                        <ReactFileReader multipleFiles={false} handleFiles={handleAddReceipt} fileTypes={[".jpeg", ".jpg", ".png", ".svg"]}>
                                                <Button 
                                                    fullWidth 
                                                    variant="outlined" 
                                                    startIcon={<UploadIcon />}
                                                    sx={{ 
                                                        borderRadius: 1, 
                                                        textTransform: 'none',
                                                        my: 1
                                                    }}
                                                >
                                                    Upload Receipt
                                                </Button>
                        </ReactFileReader>
                                            {receipt && (
                                                <Chip 
                                                    label={receipt.name} 
                                                    onDelete={handleDeleteReceipt} 
                                                    variant="outlined"
                                                    sx={{ 
                                                        color: "var(--primaryPurple)", 
                                                        borderColor: "var(--primaryPurple)",
                                                        mb: 1 
                                                    }} 
                                                />
                                            )}
                        <TerInput
                            margin="normal"
                            required
                            fullWidth
                            id="instapayUser"
                            label="Payment Username"
                            name="instapayUser"
                            autoFocus
                        />
                                            {request.status === "Accepted" && !request.receipt && request.event.paymentMethod === "InstaPay" && (
                                                <Button 
                                                    type='submit' 
                                                    variant="contained"
                                                    sx={{ 
                                                        borderRadius: 1, 
                                                        textTransform: 'none'
                                                    }}
                                                >
                                                    Send Payment
                                                </Button>
                                            )}
                                        </Stack>
                                    </CardContent>
                                </Card>
                            </>
                        )}

            {showCashMethod && (
                            <>
                                <Divider />
                                <Card 
                                    variant="outlined" 
                                    sx={{ 
                                        backgroundColor: 'white', 
                                        border: '1px solid #e0e0e0',
                                        borderRadius: '8px'
                                    }}
                                >
                                    <CardContent>
                                        <Stack spacing={2}>
                                            <Typography variant="h6" fontWeight="bold" color="var(--primaryPurple)">
                                                Call Any of these numbers to pay in cash
                                            </Typography>
                                            {request.event.paymentAddress.map((payment, index) => {
                                                return (
                                                    <Typography key={index} variant="body1" fontWeight="medium">
                                                        {payment}
                                                    </Typography>
                                                )
                                            })}
                                        </Stack>
                                    </CardContent>
                                </Card>
                            </>
                        )}
                    </Stack>
                </CardContent>

                {(role && (role === "Super" || role === "Admin") || (role && role === "User" && request.ticket && request.ticket.fulfilled) || (role && role === "User" && !request.receipt && request.status === "Accepted" && moment().isBefore(request.deadline))) && (
                    <CardActions sx={{ p: 2, pt: 0 }}>
                        <Stack direction="row" spacing={1} width="100%" justifyContent="flex-end" flexWrap="wrap">
                            {role && role === "User" && request.ticket && request.ticket.fulfilled && (
                                <>
                                    <IconButton 
                                        onClick={() => setShowQr(!showQr)}
                                        sx={{ 
                                            color: 'var(--primaryPurple)',
                                            '&:hover': { backgroundColor: 'rgba(95, 53, 184, 0.04)' }
                                        }}
                                    >
                                        <QrCode2Icon />
                                    </IconButton>
                                    <IconButton 
                                        onClick={() => downloadTicket({ ticketId: request.ticket._id })}
                                        sx={{ 
                                            color: 'var(--primaryPurple)',
                                            '&:hover': { backgroundColor: 'rgba(95, 53, 184, 0.04)' }
                                        }}
                                    >
                                        <DownloadIcon />
                                    </IconButton>
                                </>
                            )}
                            {role && role === "User" && !request.receipt && request.status === "Accepted" && moment().isBefore(request.deadline) && request.event.paymentMethod === "InstaPay" && (
                                <IconButton 
                                    onClick={() => setShowUploadReceipt(!showUploadReceipt)}
                                    sx={{ 
                                        color: 'primary.main',
                                        '&:hover': { backgroundColor: 'rgba(25, 118, 210, 0.04)' }
                                    }}
                                >
                                    <PaymentIcon />
                                </IconButton>
                            )}
                            {role && role === "User" && !request.receipt && request.status === "Accepted" && moment().isBefore(request.deadline) && request.event.paymentMethod === "Cash" && (
                                <IconButton 
                                    onClick={() => setShowCashMethod(!showCashMethod)}
                                    sx={{ 
                                        color: 'primary.main',
                                        '&:hover': { backgroundColor: 'rgba(25, 118, 210, 0.04)' }
                                    }}
                                >
                                    <PaymentIcon />
                                </IconButton>
                            )}
                            {role && (role === "Super" || role === "Admin") && (
                                <>
                                    {request.status === "Unseen" && (
                                        <>
                                            <Button 
                                                onClick={handleAccept} 
                                                variant="contained" 
                                                color="success"
                                                size="small"
                                                sx={{ borderRadius: 1, textTransform: 'none' }}
                                            >
                                                Accept
                                            </Button>
                                            <Button 
                                                onClick={handleReject} 
                                                variant="contained" 
                                                color="error"
                                                size="small"
                                                sx={{ borderRadius: 1, textTransform: 'none' }}
                                            >
                                                Reject
                                            </Button>
                                        </>
                                    )}
                                    {request.event.paymentMethod === "InstaPay" && request.receipt && (
                                        <Button 
                                            onClick={() => setShowReceipt(!showReceipt)} 
                                            variant="outlined" 
                                            size="small"
                                            sx={{ borderRadius: 1, textTransform: 'none' }}
                                        >
                                            View Receipt
                                        </Button>
                                    )}
                                    <Button 
                                        onClick={() => setShowDetails(!showDetails)} 
                                        variant="outlined" 
                                        size="small"
                                        sx={{ borderRadius: 1, textTransform: 'none' }}
                                    >
                                        {showDetails ? "Hide" : "View"} Details
                                    </Button>
                                    {request.status === "Accepted" && request.event.paymentMethod === "Cash" && (
                                        <Button 
                                            onClick={handleFulfill} 
                                            variant="contained" 
                                            color="primary"
                                            size="small"
                                            sx={{ borderRadius: 1, textTransform: 'none' }}
                                        >
                                            Validate Ticket
                                        </Button>
                                    )}
                                    {request.status === "Accepted" && request.receipt && request.event.paymentMethod === "InstaPay" && (
                                        <Button 
                                            onClick={handleFulfill} 
                                            variant="contained" 
                                            color="primary"
                                            size="small"
                                            sx={{ borderRadius: 1, textTransform: 'none' }}
                                        >
                                            Validate Ticket
                                        </Button>
                                    )}
                                </>
                            )}
                        </Stack>
                    </CardActions>
                )}
            </Card>
        </motion.div>
    )
}

const mapStateToProps = (state) => ({
    token: state?.auth?.token
});

const mapDispatchToProps = { downloadTicket, acceptTicketRequest, rejectTicketRequest, fulfillTicketRequest, payTicketRequest };

export default connect(mapStateToProps, mapDispatchToProps)(RequestCard);